export const scatterData1 = [
  { x: 3.490142459, y: 1.5852070965, label: 0.0 },
  { x: 3.9430656143, y: 6.5690895692, label: 0.0 },
  { x: 1.2975398758, y: 1.2975891292, label: 0.0 },
  { x: 6.7376384465, y: 4.3023041875, label: 0.0 },
  { x: 0.5915768422, y: 3.6276801308, label: 0.0 },
  { x: 0.6097469216, y: 0.6028107393, label: 0.0 },
  { x: 2.7258868147, y: -3.739840734, label: 0.0 },
  { x: -3.1747534975, y: 0.3131374123, label: 0.0 },
  { x: -1.038493361, y: 2.9427419978, label: 0.0 },
  { x: -0.7240722266, y: -2.236911104, label: 0.0 },
  { x: 7.1984731534, y: 4.6613355493, label: 0.0 },
  { x: 5.101292307, y: 2.8628777207, label: 0.0 },
  { x: 4.1834259132, y: 5.1663838846, label: 0.0 },
  { x: 3.2735096339, y: 5.5635470275, label: 0.0 },
  { x: 4.0990419651, y: 4.5624593753, label: 0.0 },
  { x: 4.0974400817, y: 7.7784172768, label: 0.0 },
  { x: 4.9797541629, y: 3.4134336066, label: 0.0 },
  { x: 6.2338173682, y: 3.168734525, label: 0.0 },
  { x: 5.3132953925, y: 2.0604948142, label: 0.0 },
  { x: 3.0077209267, y: 5.2952918538, label: 0.0 },
  { x: 3.10769987, y: 2.2570524218, label: 1.0 },
  { x: 1.8265275764, y: 1.5483444566, label: 1.0 },
  { x: -0.2177829856, y: 0.9202336874, label: 1.0 },
  { x: 1.3090418436, y: 3.5856833393, label: 1.0 },
  { x: 2.5154274344, y: -0.644560233, label: 1.0 },
  { x: 2.4861259541, y: 1.4223765794, label: 1.0 },
  { x: 0.9846169995, y: 2.9175144333, label: 1.0 },
  { x: 3.5464992837, y: 3.3969201787, label: 1.0 },
  { x: 0.7411737152, y: 1.5361814362, label: 1.0 },
  { x: 2.4968951471, y: 3.4633176907, label: 1.0 },
  { x: 8.2812386432, y: 8.721511535, label: 1.0 },
  { x: 7.340497539, y: 7.2056900639, label: 1.0 },
  { x: 10.2187887336, y: 11.0343600429, label: 1.0 },
  { x: 8.8919848176, y: 10.5052993468, label: 1.0 },
  { x: 9.5424540376, y: 8.0323203681, label: 1.0 },
  { x: 9.5420934083, y: 11.3070548497, label: 1.0 },
  { x: 8.9462609413, y: 11.3469654837, label: 1.0 },
  { x: 5.0703823439, y: 10.2328537566, label: 1.0 },
  { x: 9.1305706024, y: 8.5514889743, label: 1.0 },
  { x: 9.1376411648, y: 6.0186466281, label: 1.0 },
];

export const scatterData = [
  { x1: 0.0420669911, x2: 0.0654006743, y: 1.0 },
  { x1: -1.0871797908, x2: -0.0588667141, y: -1.0 },
  { x1: 0.8263531585, x2: 0.6432460448, y: -1.0 },
  { x1: 0.1652818928, x2: 0.9822824619, y: -1.0 },
  { x1: -0.7312044152, x2: 0.6264917427, y: -1.0 },
  { x1: 0.9588732274, x2: -0.4926775904, y: 1.0 },
  { x1: 0.8677574913, x2: -0.0126905525, y: -1.0 },
  { x1: 0.0951948337, x2: 0.3654662944, y: 1.0 },
  { x1: 1.7594098957, x2: -0.1217228188, y: 1.0 },
  { x1: 0.5226519651, x2: -0.367303641, y: 1.0 },
  { x1: 0.3344551751, x2: -0.2825665095, y: 1.0 },
  { x1: 0.193567658, x2: -0.092294189, y: 1.0 },
  { x1: -0.0131035757, x2: 0.5457746276, y: 1.0 },
  { x1: 1.2027170184, x2: -0.4743693622, y: 1.0 },
  { x1: -0.461879369, x2: 0.8511364229, y: -1.0 },
  { x1: 0.5899914765, x2: 0.785495859, y: -1.0 },
  { x1: -0.8970501815, x2: 0.4868508506, y: -1.0 },
  { x1: 1.4388404805, x2: -0.3884527784, y: 1.0 },
  { x1: -0.6748764251, x2: 0.7454453109, y: -1.0 },
  { x1: 0.9049651463, x2: 0.2835459134, y: -1.0 },
  { x1: 0.8749959875, x2: 0.4137537687, y: -1.0 },
  { x1: 1.9741899981, x2: -0.0044347412, y: 1.0 },
  { x1: 1.6018848171, x2: -0.2788643086, y: 1.0 },
  { x1: 2.099848417, x2: 0.280537465, y: 1.0 },
  { x1: 0.4630427834, x2: 0.9568617685, y: -1.0 },
  { x1: -0.186999284, x2: 0.9303753815, y: -1.0 },
  { x1: 0.0485431687, x2: 0.9929183962, y: -1.0 },
  { x1: 0.8550685832, x2: -0.466450014, y: 1.0 },
  { x1: -0.9701015724, x2: 0.2467113763, y: -1.0 },
  { x1: 2.0396181736, x2: 0.477786558, y: 1.0 },
];

export const circles = [
  { x1: -0.4888960549, x2: -0.0383988251, y: 1.0 },
  { x1: 0.0993915896, x2: -0.9974667855, y: -1.0 },
  { x1: -0.3263052583, x2: 0.3161565274, y: 1.0 },
  { x1: 0.0605679463, x2: 0.5880424401, y: 1.0 },
  { x1: 0.6376729364, x2: -0.6177244631, y: -1.0 },
  { x1: -0.2110403683, x2: -0.4880675897, y: 1.0 },
  { x1: 0.4395336313, x2: 0.3400497506, y: 1.0 },
  { x1: -0.2929866376, x2: -1.0197641553, y: -1.0 },
  { x1: -0.9546674583, x2: 0.1485268453, y: -1.0 },
  { x1: 0.8635752642, x2: -0.3788974988, y: -1.0 },
  { x1: -1.0060463856, x2: -0.1804166539, y: -1.0 },
  { x1: 0.3742079385, x2: -0.2613491662, y: 1.0 },
  { x1: 1.0349199471, x2: -0.0085814418, y: -1.0 },
  { x1: 0.0469090305, x2: 1.0551654626, y: -1.0 },
  { x1: 0.5392766062, x2: 0.1328005046, y: 1.0 },
  { x1: -0.4566720084, x2: -0.0889215159, y: 1.0 },
  { x1: -0.2506221751, x2: 0.9661218168, y: -1.0 },
  { x1: -0.6781325005, x2: -0.7619421042, y: -1.0 },
  { x1: 0.8903012332, x2: 0.3355753959, y: -1.0 },
  { x1: 0.7368320771, x2: 0.6599305981, y: -1.0 },
  { x1: 0.1718466603, x2: -0.4727942515, y: 1.0 },
  { x1: 0.4922675758, x2: 0.9290516618, y: -1.0 },
  { x1: -0.0519020759, x2: -0.4837237733, y: 1.0 },
  { x1: -0.2168857743, x2: 0.44506881, y: 1.0 },
  { x1: 0.0784138344, x2: -0.4341654442, y: 1.0 },
  { x1: -0.8625045201, x2: -0.5649155516, y: -1.0 },
  { x1: -0.0262154717, x2: 0.5540787167, y: 1.0 },
  { x1: 0.391138546, x2: 0.2029077188, y: 1.0 },
  { x1: -0.5720674615, x2: 0.224484116, y: 1.0 },
  { x1: -0.6493227784, x2: 0.8372276367, y: -1.0 },
  { x1: 0.219256212, x2: 0.4496573239, y: 1.0 },
  { x1: 0.4008104592, x2: -0.1850503862, y: 1.0 },
  { x1: -0.8532079989, x2: 0.5744908512, y: -1.0 },
  { x1: 0.5354523979, x2: -0.8661288143, y: -1.0 },
  { x1: -0.3681396991, x2: -0.3727995934, y: 1.0 },
];

export const moons = [
  { x1: -0.9588484435, x2: 0.1866415383, y: -1.0 },
  { x1: 1.1484861898, x2: 0.1457825164, y: -1.0 },
  { x1: 0.895181957, x2: 0.1709142495, y: -1.0 },
  { x1: 1.7209114162, x2: -0.2299073105, y: 1.0 },
  { x1: -0.2817024416, x2: 0.9181510348, y: -1.0 },
  { x1: 0.8585663464, x2: -0.3964924632, y: 1.0 },
  { x1: 0.2841866125, x2: 1.1138623333, y: -1.0 },
  { x1: 0.8368207086, x2: 0.6260202672, y: -1.0 },
  { x1: 0.4065955817, x2: 0.9007876719, y: -1.0 },
  { x1: -0.7179753897, x2: 0.6688534647, y: -1.0 },
  { x1: -0.9187088804, x2: -0.0338011069, y: -1.0 },
  { x1: -0.0223400581, x2: 0.0082875334, y: 1.0 },
  { x1: 1.8664977599, x2: 0.2755227583, y: 1.0 },
  { x1: 0.6082728168, x2: -0.4058432405, y: 1.0 },
  { x1: 0.1586574852, x2: 1.0247580857, y: -1.0 },
  { x1: 2.1118809243, x2: 0.5591653811, y: 1.0 },
  { x1: -0.4181864324, x2: 0.7186957073, y: -1.0 },
  { x1: 1.3681542689, x2: -0.5355384657, y: 1.0 },
  { x1: -0.1120340502, x2: 0.5910191452, y: 1.0 },
  { x1: 0.2647558135, x2: -0.1298301425, y: 1.0 },
  { x1: -0.9698375991, x2: 0.2060267269, y: -1.0 },
  { x1: -0.0851228336, x2: 1.0893921581, y: -1.0 },
  { x1: -0.4644558844, x2: 0.907934297, y: -1.0 },
  { x1: 1.3113947314, x2: -0.5626511926, y: 1.0 },
  { x1: 0.7601777903, x2: -0.2629583258, y: 1.0 },
  { x1: 0.6769267137, x2: 0.641734379, y: -1.0 },
  { x1: -0.9277527953, x2: 0.5549049662, y: -1.0 },
  { x1: 0.9278527923, x2: 0.5300665893, y: -1.0 },
  { x1: 0.6379562815, x2: 0.8585427542, y: -1.0 },
  { x1: 2.0080610949, x2: 0.4654663025, y: 1.0 },
  { x1: -0.5024033677, x2: 0.744512763, y: -1.0 },
  { x1: 0.0298536268, x2: 0.1754948903, y: 1.0 },
  { x1: 0.2822282378, x2: -0.0289211736, y: 1.0 },
  { x1: 1.7702842857, x2: -0.1039271502, y: 1.0 },
  { x1: 0.8659980681, x2: 0.4661251404, y: -1.0 },
  { x1: 1.1150080581, x2: -0.4666773577, y: 1.0 },
  { x1: -0.1196424354, x2: 0.3161955849, y: 1.0 },
  { x1: 0.4431827101, x2: -0.379006533, y: 1.0 },
  { x1: 1.3623460975, x2: -0.2928558407, y: 1.0 },
  { x1: 1.8211280205, x2: -0.0267924475, y: 1.0 },
];

export const spirals = [
  { x1: -3.1027299417, x2: -10.323806429, y: 1.0 },
  { x1: -2.905592117, x2: -8.7673782842, y: 1.0 },
  { x1: 3.8954873535, x2: -5.2824853303, y: -1.0 },
  { x1: -1.5608525413, x2: -4.6091172141, y: 1.0 },
  { x1: 4.9537989047, x2: -4.3944328125, y: -1.0 },
  { x1: 7.2885319411, x2: -2.7514194602, y: -1.0 },
  { x1: -1.2887219415, x2: -7.7921589198, y: 1.0 },
  { x1: 5.4976271866, x2: -2.7722584246, y: -1.0 },
  { x1: 5.6265811791, x2: -3.7232943772, y: -1.0 },
  { x1: 0.7342248908, x2: -8.4536847434, y: 1.0 },
  { x1: -2.2992341221, x2: -6.5583628712, y: 1.0 },
  { x1: -4.5414465961, x2: -8.0654877621, y: 1.0 },
  { x1: -4.0372478997, x2: -7.0534954513, y: 1.0 },
  { x1: -1.3129507496, x2: -11.9435538096, y: 1.0 },
  { x1: 3.5970542192, x2: -4.1689795785, y: -1.0 },
  { x1: 4.0955381486, x2: -5.5174231719, y: -1.0 },
  { x1: 6.2064048843, x2: -4.8720203425, y: -1.0 },
  { x1: -2.4948799277, x2: -7.4853816734, y: 1.0 },
  { x1: 7.0445898118, x2: -4.1716139362, y: -1.0 },
  { x1: -1.4104429275, x2: -10.3586895393, y: 1.0 },
  { x1: 7.1500942531, x2: -5.1488229327, y: -1.0 },
  { x1: -4.0816797839, x2: -7.8590976387, y: 1.0 },
  { x1: -2.205393977, x2: -6.6578881361, y: 1.0 },
  { x1: -3.5221751385, x2: -9.5633544649, y: 1.0 },
  { x1: -1.0418132445, x2: -8.921573724, y: 1.0 },
  { x1: 4.4752114654, x2: -3.0256956029, y: -1.0 },
  { x1: -2.5904041317, x2: -7.8048830728, y: 1.0 },
  { x1: 5.5366210163, x2: -1.7339904989, y: -1.0 },
  { x1: -0.9355119023, x2: -8.7269860597, y: 1.0 },
  { x1: 3.5083537264, x2: -4.050602698, y: -1.0 },
  { x1: 5.5173315103, x2: -2.9714706921, y: -1.0 },
  { x1: -3.0847366132, x2: -6.2486853186, y: 1.0 },
  { x1: 3.4541763222, x2: -0.1653709137, y: -1.0 },
  { x1: 7.214585983, x2: -2.9196194725, y: -1.0 },
  { x1: 7.8584060346, x2: -2.4860766787, y: -1.0 },
  { x1: 5.9438364977, x2: -2.5990202534, y: -1.0 },
  { x1: 3.9757875175, x2: -2.8368036606, y: -1.0 },
  { x1: 4.6964737697, x2: -4.1623059811, y: -1.0 },
  { x1: -0.530544551, x2: -8.4618211732, y: 1.0 },
  { x1: -3.3154556174, x2: -8.7094947342, y: 1.0 },
];
